import React from "react";
import useHover from "../hooks/useHover";

const CollectionButton = ({ cat, onCatSelected, selectedBoxType }) => {
  const hover = useHover();
  return (
    <div
      {...hover.divProps}
      className="divRow"
      onClick={() => onCatSelected(cat)}
      style={{
        width: "100px",
        justifyContent: "center",
        padding: "5px",
        backgroundColor: "#2f2f2f",
        borderRadius: "5px",
        border: "2px solid white",
        cursor: "pointer",
        opacity: cat == selectedBoxType ? 1 : 0.5,
      }}
    >
      <div className="textBoldWhite" style={{ fontSize: "18px" }}>
        {cat}
      </div>
    </div>
  );
};

export default CollectionButton;
